module.exports = __webpack_public_path__ + "static/media/Step3.77010296.png";